import React from 'react';
import { Box, Typography } from '@lucid/lego';
import { useStore } from '../../../store/store';

/**
 * Order Desk page component
 * @component
 * @returns JSX.Element
 */
const OrderDesk: React.FC = () => {
  const theme = useStore((state) => state.theme);

  return (
    <Box>
      <Typography variant="headline" size="small" color="primary-1" theme={theme}>
        Order Desk
      </Typography>
      <Box pt={24}>
        <Typography variant="body" size="medium" color="gray-3" theme={theme}>
          Order Desk content will go here.
        </Typography>
      </Box>
    </Box>
  );
};

export default OrderDesk;
